var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "box",
    {
      attrs: {
        customClass: "fields-container",
        "no-shadow": "",
        "no-top-border": "",
        "no-border": ""
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _vm.build
            ? _c("form-fields", {
                attrs: { parameters: _vm.parameters },
                on: { fieldUpdated: _vm.fieldUpdated }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2d45baa", { render: render, staticRenderFns: staticRenderFns })
  }
}